// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Yp-z","slideIn":"Zp-z"};